import { ReactComponent as ChevronIcon } from 'assets/icons/chevron.svg';
import { clsx } from 'clsx';

import type { KeyboardEvent } from 'react';
import type { IValueChainGroupItem } from './interfaces/IValueChainGroupItem';

import styles from './scss/ValueChainGroupItem.module.scss';

function ValueChainGroupItem({
  title,
  count,
  isExpanded,
  onToggle,
  cardType,
  className,
}: IValueChainGroupItem) {
  const handleClick = () => {
    onToggle();
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    onToggle();
  };

  return (
    <div className={clsx(styles.stack, className)}>
      <div className={styles.card} data-type={cardType}>
        <div
          role="button"
          tabIndex={0}
          aria-expanded={isExpanded}
          aria-label={title}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          className={styles.header}
        >
          <span className={styles.icon} aria-hidden>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="9" y="3" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.6" />
              <rect x="3" y="16" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.6" />
              <rect x="15" y="16" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.6" />
              <path
                d="M12 8v3M6 16v-2h12v2M12 11v3"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <span className={styles.title} title={title}>{title}</span>
          <span className={styles.count}>{count}</span>
          <ChevronIcon className={clsx(styles.chevron, isExpanded && styles.chevronExpanded)} aria-hidden />
        </div>
      </div>
      {!isExpanded ? (
        <div className={styles.layers} aria-hidden>
          <span className={styles.layer} />
          <span className={styles.layer} />
          <span className={styles.layer} />
        </div>
      ) : null}
    </div>
  );
}

export default ValueChainGroupItem;
